import { Dialog, DialogTitle, DialogContent, FormControlLabel, Checkbox } from "@mui/material";
import { useEffect, useState } from "react";
import NonDisclousre from "./NonDisclousre";
import Guidlines from "./Guidlines";
import Handbook from "./Handbook";
import IMSPolicy from "./IMSPolicy";
import ConflictOfInterestPage from "./ConflictOfInterestPage";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { AddButton } from "../../utils/Custom/Button";

export default function PolicyAgreementModal({ inspectorDetails, open, onClose }) {
  const [pageIndex, setPageIndex] = useState(0);
  const [checkboxes, setCheckboxes] = useState([]);
  const userID = localStorage.getItem("id");

  useEffect(() => {
    setCheckboxes(new Array(pages.length).fill(false));
  }, [open]);

  const pages = [
    {
      title: "CONFLICT OF INTEREST AND IMPARTIALITY AGREEMENT",
      content: <ConflictOfInterestPage inspectorDetails={inspectorDetails} />,
    },
    {
      title: "NON-DISCLOSURE AND INTELLECTUAL PROPERTY RIGHTS AGREEMENT",
      content: <NonDisclousre inspectorDetails={inspectorDetails} />,
    },
    {
      title: "Minimum Guidelinesto AIPL Inspectors",
      content: <Guidlines inspectorDetails={inspectorDetails} />,
    },
    {
      title: "Employee Handbook",
      content: <Handbook inspectorDetails={inspectorDetails} />,
    },
    {
      title: "IMS-QEHS POLICY",
      content: <IMSPolicy inspectorDetails={inspectorDetails} />,
    },
  ];

  const isLast = pageIndex === pages.length - 1;

  const handleCheckbox = (index) => {
    const updated = [...checkboxes];
    updated[index] = !updated[index];
    setCheckboxes(updated);
  };

  const handleSubmit = async () => {
    try {
      await axiosWithToken.patch(`/users/${userID}`, { policyStatus: 1, policyDate: new Date() });
      localStorage.setItem("policyStatus", 1);
      onClose();
    } catch (err) {
      console.error("Error updating policy status", err);
    }
  };

  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <DialogTitle>
        <div className="border border-black text-center font-bold py-2">
          {pages[pageIndex].title}
        </div>
      </DialogTitle>

      <DialogContent dividers>
        <div className="space-y-4">{pages[pageIndex].content}</div>

        <FormControlLabel
          className="mt-10"
          control={
            <Checkbox
              checked={checkboxes[pageIndex]}
              onChange={() => handleCheckbox(pageIndex)}
              color="primary"
            />
          }
          label="I have read and agree to all applicable terms, policies, and conditions."
        />
      </DialogContent>

      <div className="flex justify-between p-4 border-t">
        <AddButton
          onClick={() => setPageIndex((prev) => Math.max(prev - 1, 0))}
          disabled={pageIndex === 0}
         label={"Previous"}
        />

        <AddButton
          id="btn-add-outline"
          label={isLast ? "Submit" : "Next"}
          disabled={!checkboxes[pageIndex]}
          onClick={() => {
            if (isLast) {
              handleSubmit();
            } else {
              setPageIndex((prev) => prev + 1);
            }
          }}
        />
      </div>
    </Dialog>
  );
}
